import { Link } from "react-router-dom";
import { IContactDetails } from "../../../interfaces/models/IEvent";
import { ReactComponent as EmailIcon } from "../../../../src/assets/images&icons/email.svg";
import { useParams } from "react-router-dom";
import { useEventLoader } from "../../../hooks/Events/useEventLoader";
import ProfilePhoto from "../../../components/Atomos/ProfilePhoto";
import { formatPhoneForDisplay } from "../../../utils/formatPhoneForDisplay";
import { resolveProfilePictureDisplayUrl } from "../../../utils/profilePictureUrl";
import {
  buildFirmProfilePath,
  buildPersonProfilePath,
} from "../../../utils/publicProfileUrls";

export default function MemberContactUsTab() {
  const { id } = useParams<{ id: string }>();
  const event = useEventLoader(id);
  if (!event) {
    return <div>Event not found</div>;
  }
  return (
    <div className="mb-0">
      <h1 className="text-[26px] md:text-[30px] lg:text-[32px] font-medium text-primary mb-4 leading-9 font-decimal text-left">
        Contact Us
      </h1>
      <div className="bg-[#F6F6F6] pb-4 pt-4">
        <div className="border-b border-primary pb-0 flex-shrink-0 mb-4 inline-block">
          <h3 className="text-[22px] font-normal text-gray-font leading-4 md:leading-5 text-left font-sans pl-4 md:pl-8 mb-2">
            Contacts
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-5">
          {event.contactUsDetails?.map((contact: IContactDetails) => {
            const contactPhotoSrc = contact.id
              ? resolveProfilePictureDisplayUrl(contact.id, contact.photo)
              : "";
            const personPath = buildPersonProfilePath(
              contact.name,
              "",
              contact.personLegacyId
            );
            const firmPath = buildFirmProfilePath(
              contact.firmName,
              contact.firmShortId || contact.firmLegacyId
            );
            return (
            <div key={contact.id} className="flex items-start min-w-0">
              <div className="w-16 h-16 xs:w-20 xs:h-20 sm:w-24 sm:h-24 md:w-[90px] md:h-[90px] rounded-full mr-3 xs:mr-4 sm:mr-5 md:mr-6 flex-shrink-0 overflow-hidden flex items-center justify-center">
                <ProfilePhoto
                  src={contactPhotoSrc}
                  alt={contact.name}
                  imgClassName="w-full h-full object-cover object-[center_25%]"
                />
              </div>
              <div className="flex flex-col min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-0 min-w-0">
                  {personPath ? (
                    <Link
                      to={personPath}
                      className="font-Roboto font-bold text-gray-font text-[18px] md:text-[20px] hover:text-red-600 hover:underline transition-colors text-left break-words"
                    >
                      {contact.name}
                    </Link>
                  ) : (
                    <span className="font-Roboto font-bold text-gray-font text-[18px] md:text-[20px] text-left break-words">
                      {contact.name}
                    </span>
                  )}
                </div>
                <p className="font-Roboto font-normal text-[#474F56] text-[16px] md:text-[17px] lg:text-[18px] mb-2 text-left italic break-words">
                  {contact.title || "Partner"}
                </p>

                {
                  <div className="flex flex-row flex-wrap md:flex-nowrap items-center justify-start gap-2 min-w-0">
                    <p className="font-Roboto font-[350] text-[#474F56] text-[16px] md:text-[17px] lg:text-[18px] text-left break-words">
                      {formatPhoneForDisplay(contact.phone, { includeBasecode: false }) ||
                        "No phone number"}
                    </p>
                    <span className="w-0.5 h-4 bg-gray-300 inline-block flex-shrink-0"></span>
                    <button
                      onClick={() =>
                        window.open(`mailto:${contact.email}`, "_blank")
                      }
                      className="flex items-center gap-2 group flex-shrink-0"
                      title={`Email ${contact.name}`}
                    >
                      <div className="w-6 h-6 bg-blue-600 text-white rounded-full group-hover:bg-red-600 transition-colors flex items-center justify-center flex-shrink-0">
                        <EmailIcon className="w-4 h-4" />
                      </div>
                      <p className="font-Roboto font-normal text-[#474F56] text-[16px] md:text-[17px] lg:text-[18px] text-left group-hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap">
                        Email
                      </p>
                    </button>
                  </div>
                }
                {contact.firmName &&
                  (firmPath ? (
                    <Link
                      to={firmPath}
                      className="font-Roboto font-[350] text-[#0070CD] text-[16px] md:text-[17px] lg:text-[18px] hover:text-red-600 hover:underline transition-colors text-left block break-words"
                    >
                      {contact.firmName}
                    </Link>
                  ) : (
                    <span className="font-Roboto font-[350] text-[#474F56] text-[16px] md:text-[17px] lg:text-[18px] text-left block break-words">
                      {contact.firmName}
                    </span>
                  ))}
                {contact.countryName || contact.stateName ? (
                  <div className="flex flex-row flex-wrap md:flex-nowrap items-center gap-2 min-w-0">
                    <p className="font-Roboto font-normal text-[#474F56] text-[16px] md:text-[17px] lg:text-[18px] mb-2 text-left italic break-words">
                      {contact.countryName}
                    </p>
                    {contact.countryName && contact.stateName && <span className="text-[#474F56] text-[16px] md:text-[17px] lg:text-[18px] mb-2 text-left italic flex-shrink-0">
                      -
                    </span>}
                    <p className="font-Roboto font-normal text-[#474F56] text-[16px] md:text-[17px] lg:text-[18px] mb-2 text-left italic break-words">
                      {contact.stateName}
                    </p>
                  </div>
                ) : (
                  <p className="font-Roboto font-normal text-[#474F56] text-[16px] md:text-[17px] lg:text-[18px] mb-2 text-left italic break-words">
                    Texas - USA
                  </p>
                )}
              </div>
            </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
